import React, { useState, useCallback } from "react";
import { useModal } from "react-modal-hook";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import Modal from "../../../components/Modal/Modal";
import InputError from "../../../components/InputError/InputError";
import NeoOTP from "../../../components/FormComponents/NeoOTP";
import NeoButton from "../../../components/NeoButton/NeoButton";
import NeoInput from "../../../components/NeoInput/NeoInput";
import NeoLoader from "../../../components/FormComponents/NeoLoader";
import { useHistory } from "react-router-dom";
import CheckMarkIcon from "custom/assets/icons/requests/709510";
import AccountDisplay from "../../../components/account-display/account-display";
import { ChequeStatusSchema } from "../../../schemas/requests";
import LayoutWithAccountCard from "../../Layout/layout-account-card";
import RequestService from "../../../services/request.service";
import {
  BUTTON_KEYS,
  CHEQUE_STATUS_KEYS,
} from "../../../utils/translation-constants";
import { useTranslation } from "react-i18next";
import {
  getCurrentAccDetailsSelector,
} from "../../../store/selectors/app.selector";
import validationConfig from "custom/config/validation.config.json";
const chequeStatusConfig = validationConfig["OtherService"]["chequeStatus"];
import { Link } from "react-router-dom";

export default function ChequeStatus() {
  const { t } = useTranslation();
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [stage, setStage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    accountNumber: "",
    chequeNumber: "",
  });
  const [message, setMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [responseValues, setResponseValues] = useState({});
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector);
  const [verifyDetails, setVerifyDetails]=useState({})

  const history = useHistory();

  const chequeStatus = {
    N: t(CHEQUE_STATUS_KEYS.NOT_UTILIZED),
    U: t(CHEQUE_STATUS_KEYS.UTILIZED),
    S: t(CHEQUE_STATUS_KEYS.STOPPED),
    R: t(CHEQUE_STATUS_KEYS.REJECT),
  }


  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className="modal-error-body">
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className="modal-btn-style">
            <NeoButton
              tabIndex="1"
              mode="newDesign"
              type="button"
              text={t(BUTTON_KEYS.CLOSE)}
              onClick={() => {
                hideModal();
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();
      case 2:
        return renderConfirmation();
      case 3:
        return (
          <NeoOTP
            loading={loading}
            otp={otp}
            setOTP={setOtp}
            onSubmit={confirmChequeStatus}
          />
        );
      case 4:
        return renderSuccess();
      default:
        return renderForm();
    }
  }

  const onSubmitChequeStatus = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setSubmitting(true);
        setFormValues(data);
        const response = await RequestService.verifyChequeStatus({
          srcAccount: currentAccountDetail?.accountNo,
          chequeNo: data.chequeNumber,
          brnCode: currentAccountDetail?.brnCode,
        });
        if (response.status === 200) {
          setVerifyDetails(response.data)
          setSubmitting(false);
          setLoading(false);
          setOtpEnabled(response.data["otpEnable"]);
          setLoading(false);
          setStage(2);
        }
      } catch (err) {
        setSubmitting(false);
        setLoading(false);
      }
    },
    [currentAccountDetail, showModal, verifyDetails]
  );

  const confirmChequeStatus = useCallback(async () => {
    try {
      setLoading(true);
      const response = await RequestService.ConfirmChequeStatus({
        srcAccount: currentAccountDetail?.accountNo,
        chequeNo: formValues.chequeNumber,
        otp,
        brnCode: currentAccountDetail?.brnCode,
        randomKey:verifyDetails.randomKey
      });
      if (response.status === 200) {
        setResponseValues(response.data);
        setStage(4);
      }
    } catch (err) {
      setOtp("");
      setLoading(false);
    }
  }, [otp, formValues, currentAccountDetail, verifyDetails]);

  function renderLoading() {
    return (
      <div className="mx-4 rounded d-flex justify-content-center align-items-center">
        <NeoLoader width="50px" height="50px" />
      </div>
    );
  }

  function renderForm() {
    return (
      <div>
        <div className="heading-style">{t(CHEQUE_STATUS_KEYS.TITLE)}</div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formValues}
          validationSchema={ChequeStatusSchema}
          onSubmit={onSubmitChequeStatus}
        >
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className="form-group">
                <NeoInput
                  tabIndex="1"
                  showAsterisk={chequeStatusConfig["isChequeNoRequired"]}
                  text={t(CHEQUE_STATUS_KEYS.CHEQUE_NUMBER)}
                  onChange={handleChange}
                  name="chequeNumber"
                />
                <InputError
                  text={errors.chequeNumber}
                  touched={touched.chequeNumber}
                />
              </div>
              <div className="mt-3 form-group">
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex="2"
                    type="submit"
                    mode="newDesign"
                    disabled={isSubmitting}
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
              <button tabIndex={'3'} className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                onClick={() => history.goBack()}
              >
                {" "}
                {t(BUTTON_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }

  function renderConfirmation() {
    return (
      <div className="d-flex flex-column confirmation">
        <h3>{t(CHEQUE_STATUS_KEYS.SUBTITLE)}</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div>
          <h6 className="label">{t(CHEQUE_STATUS_KEYS.CHEQUE)}</h6>
          <h6 className="value">{formValues.chequeNumber}</h6>
        </div>
        <div className="mt-3">
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type="button"
              mode="newDesign"
              text={t(BUTTON_KEYS.CONFIRM)}
              onClick={() => (otpEnabled ? setStage(3) : confirmChequeStatus())}
            />
          )}
        </div>
        <div className="back-cancel-style" onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    );
  }

  function renderSuccess() {
    return (
      <div className="d-flex flex-column">
        <div
          className="row justify-content-center align-items-center"
          style={{ marginBottom: 20 }}
        >
          <CheckMarkIcon height="150px" width="150px" />
        </div>
        <div className="d-flex flex-column confirmation">
          <div>
            <h6 className="label">
              {t(CHEQUE_STATUS_KEYS.ACCOUNT_NUMBER)}
            </h6>
            <h6 className="value">{responseValues?.accountNo || "-"}</h6>
          </div>
          <div>
            <h6 className="label">{t(CHEQUE_STATUS_KEYS.CHEQUE_NUMBER)}</h6>
            <h6 className="value">{responseValues.chequeNo || "-"}</h6>
          </div>
          <div>
            <h6 className="label">
              {t(CHEQUE_STATUS_KEYS.AMOUNT)}
            </h6>
            <h6 className="value">{responseValues?.amount || "-"}</h6>
          </div>
          <div>
            <h6 className="label">{t(CHEQUE_STATUS_KEYS.STATUS)}</h6>
            <h6 className="value">
              {chequeStatus[responseValues.chequeStatus]}
            </h6>
          </div>
          <div>
            <h6 className="label">
              {t(CHEQUE_STATUS_KEYS.BENEFICIARY_ACCOUNT)}
            </h6>
            <h6 className="value">{responseValues.beneAccNo || "-"}</h6>
          </div>
          <div>
            <h6 className="label">{t(CHEQUE_STATUS_KEYS.DATE_ON_CHECK)}</h6>
            <h6 className="value">{responseValues.dateOnCheque || "-"}</h6>
          </div>
        </div>
        <div className="mt-4 mx-auto px-0 col-3">
          <Link to="/requests">
            <NeoButton
              type="button"
              mode="newDesign"
              text={t(BUTTON_KEYS.DONE)}
            />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <LayoutWithAccountCard breadCumKey="CHEQUE_STATUS">
      <div className="new-design-form-style"> {renderSwitch()}</div>
    </LayoutWithAccountCard>
  );
}
